const bpak = {
  hero: {
    title: 'БпАК PEGASUS ARMS 25 — надійне рішення для бойових задач',
    paragraphs: [
      'БпАК Pegasus Arms 25 — безпілотний авіаційний комплекс, розроблений українськими інженерами з урахуванням сучасних викликів на полі бою. Система поєднує високу ударну ефективність, стійкість до засобів РЕБ та адаптивність до завдань різної складності. ',
      'Завдяки БпАК Pegasus Arms 25 підрозділи отримують автономний інструмент для ураження техніки, живої сили, інженерних споруд без прямих втрат серед особового складу. Це рішення, яке зберігає життя, скорочує час на виконання завдання та дозволяє діяти незалежно: у будь-який час доби, легких та складних метеоумовах, у режимі автономного повернення та стійкості до РЕБ.',
    ],
  },
  advantages: {
    title: 'Технічні переваги БПАК',
    timeLine: [
      {
        title: 'Корисне навантаження',
        description:
          '14 кг: підтримка ПГ-7, ТМ, СВП та інших боєприпасів для виконання широкого спектру завдань: від ударів по техніці до дистанційного мінування.',
      },
      {
        title: 'Дальність бойового застосування',
        description:
          'до 20 км. Дозволяє знищувати ворога без загрози для екіпажу БпАК.',
      },
      {
        title: 'GNSS-АНТЕНА',
        description:
          'GNSS-АНТЕНА власної розробки підвищує точність і надійність навігації в умовах спуфінгу та глушіння.',
      },
      {
        title: 'Стійкість до засобів РЕБ',
        description:
          'стабільне керування та виконання місії навіть у зоні активного радіоелектронного тиску.',
      },
      {
        title: 'Біспектральна камера',
        description: '(оптика+тепловізор) забезпечує цілодобове цілевказання.',
      },
      {
        title: 'Автономного повернення',
        description:
          'Функція автономного повернення при втраті сигналу. Мінімізує ризик втрати БпЛА навіть у складних бойових умовах.',
      },
    ],
  },
  composition: {
    title: 'Склад БпАК PEGASUS ARMS 25',
    paragraphs: [
      'Має декілька варіантів комплектації та оснащення, в залежності від типу завдання: під удар, логістику або дистанційне мінування.',
      "До одного комплексу можна під'єднати будь-яку кількість БпЛА Pegasus Arms 25.",
    ],
    items: [
      'Безпілотний літальний апарат',
      'Наземна станція управління з пультом дистанційного керування',
      'Ноутбук для БпЛА та портативний монітор',
      "Модуль зв'язку",
      'АКБ',
      'Програмне забезпечення',
      'Кейс для транспортування, зберігання приладдя та допоміжного обладнання',
      'Експлуатаційна документація',
    ],
  },
}
export default bpak
